import type {ContentBlocksFragment} from '@/modules/foundation/sanity/content-blocks/query';
import type {KeyedArray} from '@/modules/foundation/shared/types';

import type {Person} from '../../shared/types';
import {PERSON_IN_CARD_FRAGMENT, personFromPersonInCardFragment} from '../query';

import type {BLOCK_TYPE_PERSON_LIST_SELECTION} from './constants';

export const PERSON_LIST_SELECTION_FRAGMENT = `//groq
	...,
	persons[]-> {
		${PERSON_IN_CARD_FRAGMENT}
	}
`;

export type PersonListSelectionFragment = Extract<
	ContentBlocksFragment[number],
	{_type: typeof BLOCK_TYPE_PERSON_LIST_SELECTION}
>;

export const personListFromPersonListSelectionSection = (
	section: PersonListSelectionFragment,
): KeyedArray<Person> => {
	if (!section.persons) {
		return [];
	}

	return section.persons.map((person) => {
		return {
			_key: person?._id ?? '',
			...personFromPersonInCardFragment(person),
		};
	});
};
